// Import components
import CreateButton from "global/components/CreateButton";



// Function to render the search between dates selector (from and to date picker with button to submit)
const CreateDateFilterPickers = ({

    filterStartDate,

    setFilterStartDate,

    filterEndDate,

    setFilterEndDate,

    maxDate,

    handleDateFilterSubmit,

    buttonTitle,

    activeStartDate,

    activeEndDate,

    datePickerMessage

}) => {


    // This checks whether the picker dates are different from the dates currently used by the table
    const datesHaveChanged = filterStartDate !== activeStartDate || filterEndDate !== activeEndDate;



    return (

        <>
            

                <div className="filters__date-range">

                    <div className="filters__date-inputs" style={{marginBottom: datePickerMessage ? "5px" : ""}}>

                        <label className="filters__date-label">

                            <input
                                type="date"
                                max={filterEndDate || maxDate}
                                value={filterStartDate || ""}
                                onChange={(e) => setFilterStartDate(e.target.value)}
                                className="filters__date-picker"
                            />
                        </label>

                        <span style={{ fontSize: "1.2rem" }}><b>⬌</b></span>

                        <label className="filters__date-label">

                            <input
                                type="date"
                                min={filterStartDate}
                                max={maxDate}
                                value={filterEndDate || ""}
                                onChange={(e) => setFilterEndDate(e.target.value)}
                                className="filters__date-picker"
                            />
                        </label>

                        <CreateButton
                            title={buttonTitle}
                            size="s"
                            type="button"
                            onClick={handleDateFilterSubmit}
                            invert={!datesHaveChanged}
                            disabled={!filterStartDate || !filterEndDate}
                        />

                    </div>
                    
                    {datePickerMessage &&

                        <p>{datePickerMessage}</p>

                    } 

                </div>

            

        </>

    )

};

export default CreateDateFilterPickers;


